import { SET_EVE_CLIENT_VERSION, SET_LAUNCHER_BACKEND_VERSION } from './constants'

const initialState = { clients: {} }
// const initialState = {
//     clients: {
//         tq: 1231745,
//         sisi: 1231303,
//     },
//     backend: 1225328,
// }

const getNumber = (input, defaultValue) => {
    try {
        return parseInt(input, 10)
    } catch (error) {
        if (defaultValue != null) return defaultValue
        return -1
    }
}

export default function versions(state = initialState, action) {
    switch (action.type) {
        // Update the EVE client version
        case SET_EVE_CLIENT_VERSION:
            return {
                ...state,
                clients: {
                    ...state.clients,
                    [action.payload.serverId]: getNumber(action.payload.version),
                },
            }

        // Update the launcher backend version
        case SET_LAUNCHER_BACKEND_VERSION:
            return {
                clients: { ...state.clients },
                backend: getNumber(action.payload),
            }

        default:
            return state
    }
}



// WEBPACK FOOTER //
// ./src/features/Backend/data/versions/reducer.js